exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "*[data-v-6fed7137]{cursor:auto}\n", ""]);

